import React from 'react';

const Skeleton = ({ width, height, rounded = 'md', className = '' }) => {
  const roundedClasses = {
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    full: 'rounded-full',
  };

  return (
    <div
      className={`bg-gray-200 dark:bg-gray-800 animate-pulse-soft ${roundedClasses[rounded]} ${className}`}
      style={{ width, height }}
    />
  );
};

export const SkeletonText = ({ lines = 3, className = '' }) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height="1rem"
          width={i === lines - 1 ? '70%' : '100%'}
          rounded="sm"
        />
      ))}
    </div>
  );
};

export const SkeletonCard = ({ className = '' }) => {
  return (
    <div className={`p-6 bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded-xl ${className}`}>
      <div className="flex items-center gap-4 mb-4">
        <Skeleton width="3rem" height="3rem" rounded="full" />
        <div className="space-y-2 flex-1">
          <Skeleton height="1.25rem" width="40%" />
          <Skeleton height="0.875rem" width="20%" />
        </div>
      </div>
      <SkeletonText lines={2} />
    </div>
  );
};

export default Skeleton;
